const KEYS_ALLOWED: readonly string[] = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  'Backspace',
  'Escape',
  'ArrowLeft',
  'ArrowRight',
  'Delete',
  'Control',
  'Meta', // Command key on mac
  'Alt', // Option key on mac
  'Tab',
]

const CTRL_KEY_CODES_ALLOWED: readonly number[] = [
  65, // a & A
  67, // c & C
  82, // r & R
  86, // v & V
  88, // x & X
]

export const onlyNumber = (event: KeyboardEvent, float: boolean = false): void => {
  const keysAllowed = float ? [...KEYS_ALLOWED, '.'] : KEYS_ALLOWED

  if (
    keysAllowed.includes(event.key) ||
    (event.ctrlKey && CTRL_KEY_CODES_ALLOWED.includes(event.keyCode)) ||
    (event.metaKey && CTRL_KEY_CODES_ALLOWED.includes(event.keyCode))
  ) {
    return
  }

  event.preventDefault()
}
